import { getTokenPayload } from "@/token/token";
import {
  fileUploadComplete,
  magicFileUrl,
  magicImageUrl,
  videosMaP,
} from "../slices/product-processing-slices/CartSlice";
import { store } from "../stores/store";
import { showNotification } from "../slices/AlertMessageSlice";
import API from "./API";

export const fileUploadApi = ({ file, fileType, onProgress, onProcess }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const tokenPayload = getTokenPayload("token");

      const payload = {
        fileName: file.name,
        contentType: file.type,
        fileType,
        userId: tokenPayload?.sub || 0,
      };

      const res = await store.dispatch(magicFileUrl(payload));

      if (!magicFileUrl.fulfilled.match(res)) {
        store.dispatch(
          showNotification({
            messageToaster: true,
            toasterType: "error",
            toasterMessage:
              res?.error?.message ||
              "Something went wrong! Please check your internet connection.",
          }),
        );
        return reject(res?.error);
      }

      const resData = res.payload.response;

      const xhr = new XMLHttpRequest();
      xhr.open("PUT", resData.uploadUrl);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          onProgress?.((event.loaded / event.total) * 100);
        }
      };

      xhr.onload = async () => {
        if (xhr.status !== 200) {
          onProcess?.(false);
          return reject(new Error(`Upload failed with status ${xhr.status}`));
        }

        onProcess?.(true);
        onProgress?.(100);

        store.dispatch(
          showNotification({
            messageToaster: true,
            toasterType: "success",
            toasterMessage: "File uploaded successful!",
          }),
        );

        const payload2 = {
          uploadId: resData?.uploadId || "",
          contentType: file.type,
          contentLength: file.size,
          encryptedDataKeyBase64: resData?.encryptedDataKeyBase64 || "",
          nonceBase64: resData?.nonceB64 || "",
        };

        const ReturnablePayload = {
          uploadId: resData?.uploadId || "",
          name: resData?.fileName || "",
          url: resData?.url || "",
          fileName: resData?.fileName || "",
          uploadThumbnailUrl: resData?.url || "",
          fileType: fileType,
        };

        const res2 = await store.dispatch(fileUploadComplete(payload2));

        if (!fileUploadComplete.fulfilled.match(res2)) {
          store.dispatch(
            showNotification({
              messageToaster: true,
              toasterType: "error",
              toasterMessage:
                res?.error?.message ||
                "Something went wrong! Please check your internet connection.",
            }),
          );
          return reject(res2?.error);
        }

        resolve(ReturnablePayload);
      };

      xhr.onerror = () => reject(new Error("XHR upload failed"));
      xhr.send(file);
    } catch (err) {
      reject(err);
    }
  });
};

export const deleteMagicFileApi = async (uploadId) => {
  try {
    const response = await API.delete(`/v1/upload/${uploadId || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};
